import React, { Fragment, useEffect } from "react";
import Header from "../subheader/Header";
import "./report.scss";
import ReportCard from "./components/ReportCard";
import { ReportsData } from "../../../Extra/Reports";
import { CenteredSpinner } from "../../../components/centeredSpinner/CenteredSpinner";

const Report = () => {
  const Data = ReportsData;

  useEffect(() => {
    document.title = "Reports";
  }, []);

  return (
    <Fragment>
      <div className="vendor-page-right report-page-desktop">
        <Header
          heading="Reports"
          search={false}
          filters={{ status: false, date_filter: false }}
        />
        {Data ? (
          <div className="right-content report-page-right-content">
            <div className="content-container page-container">
              <div className="content-wrapper">
                <div className="top-reports-row d-flex flex-wrap">
                  {Data.map((report) => {
                    return (
                      <div className="report" key={report.report_id}>
                        <ReportCard report={report} />
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        ) : (
          <CenteredSpinner height="calc(100vh - 123px)" />
        )}
      </div>
    </Fragment>
  );
};

export default Report;
